module.exports = __webpack_public_path__ + "media/images/undraw_culture-764b958d34fa1c83c2dc5e8107e19e0e.svg";